import dayjs from 'dayjs';

import { OptionAssetGrantFragment, OptionAssetInfosFragment } from '@blockpulse3/graphql/hooks';

export enum OptionGrantStatus {
  ATTRIBUTED = 'ATTRIBUTED',
  SUBSCRIBED = 'SUBSCRIBED',
  VESTING = 'VESTING',
  CADUC = 'CADUC',
}

export function getOptionAssetGrantStatus(
  grant: OptionAssetGrantFragment,
  option: OptionAssetInfosFragment,
): string {
  const endAttributionDate = dayjs.unix(grant.date).add(option.attributionPeriod, 'seconds');
  const endSubscriptionDate = dayjs.unix(grant.date).add(option.subscriptionPeriod, 'seconds');
  const endVestingDate = dayjs.unix(grant.date).add(option.vestingCurve.vestingDuration, 'seconds');

  const dateOption = dayjs.unix(option.date);

  if (dateOption.isBefore(endAttributionDate)) {
    return OptionGrantStatus.ATTRIBUTED;
  }

  if (dateOption.isBefore(endSubscriptionDate)) {
    return OptionGrantStatus.SUBSCRIBED;
  }

  if (dateOption.isBefore(endVestingDate)) {
    return OptionGrantStatus.VESTING;
  }

  return OptionGrantStatus.CADUC;
}
